/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Contract_BadgeInputs */



/**
* | output |
* | --- |
* | "Covered by contract — not invoiced" |
*
* @param {Partner_Billing_Contract_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_contract_badge = /** @type {((inputs?: Partner_Billing_Contract_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Contract_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Durch Vertrag abgedeckt — nicht berechnet")
	return /** @type {LocalizedString} */ ("Covered by contract — not invoiced")
});